<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">Student Name: {{ student.full_name_en }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <ts-audio-recorder
          :timer="true"
          timer-color="#333"
          :timer-font-size="1.2"
          timer-background="#eee"
          :audio-width="350"
          @audioFile="myAudioFile"
          :src="audioUrl"
          :resource-id="student.student_id"
        />
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
export default {
  name: 'StudentAudio',
  props: ['student'],
  data () {
    return {}
  },
  computed: {
    audioUrl () {
      if (this.student.audio_file_name === null) return ''

      return this.student.audio_file_name
    }
  },
  methods: {
    myAudioFile (audioFile) {
      if (audioFile === null) return

      let formData = new FormData()
      formData.append('audio', audioFile)
      formData.append('student_id', this.student.student_id)

      this.$store
        .dispatch('studentProfile/uploadAudio', formData)
        .then(async () => {
          await this.$store.dispatch('studentProfile/fetch').catch(error => {
            this.$toasted.error(error.message)
          })
        })
    }
  }
}
</script>
